module.exports = __webpack_public_path__ + "img/air-vapormax-plus-mens-shoe-fPnNXW.d7da84eb.png";